import { render } from "./PackageCard.vue?vue&type=template&id=6cd4962c"
import script from "./PackageCard.vue?vue&type=script&lang=js"
export * from "./PackageCard.vue?vue&type=script&lang=js"

import "./PackageCard.vue?vue&type=style&index=0&id=6cd4962c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__